import React from 'react';

import { useAppTranslations } from '@treneo/shared/i18n';

import { Button, BUTTON_VARIANTS } from './components/button';
import type { DialogProps } from './components/dialog';
import { HeadDialog } from './head-dialog';

type Props = {
  open: DialogProps['open'];
  content: React.ReactNode;
  onNo: () => void;
  onYes: () => void;
};

export const ConfirmationDialog = ({ open, content, onNo, onYes }: Readonly<Props>) => {
  const { t } = useAppTranslations();

  return (
    <HeadDialog
      content={content}
      buttons={
        <>
          <Button variant={BUTTON_VARIANTS.outlined} onClick={onNo}>
            {t('No')}
          </Button>
          <Button variant={BUTTON_VARIANTS.contained} onClick={onYes}>
            {t('Yes')}
          </Button>
        </>
      }
      onClose={onNo}
      open={open}
    />
  );
};
